import {Box} from '@mui/material';
import React, {Fragment} from 'react';

import {MainFooter} from 'presentation/components';
import {TelemedicineEnum} from 'presentation/pages/private/booking/constants';
import {translations} from 'presentation/translations-new';
import {TypeAttendance} from 'presentation/modules/myAppointments/constants/typeAttendanceEnum';
import {AppointmentInfo} from '../AppointmentInfo';
import {ConcludedAlert} from 'presentation/modules/myAppointments/ui/components/ConcludedAlert';
import {MyAppointmentsHistoryDetailsContentProps} from './types';

const {
	appointmentCarriedOut,
	emergencyAppointmentCarriedOut,
	telehealthAppointmentCarriedOut,
	surgeryAppointmentCarriedOut,
} = translations['pt-br'].privateFlow.myAppointments.appointmentCard;

export function MyAppointmentsHistoryDetailsContent({
	appointmentHistoryDetailsData,
}: MyAppointmentsHistoryDetailsContentProps) {
	const isEmergency = appointmentHistoryDetailsData.typeAttendance === TypeAttendance.EMERGENCY;
	const isSurgery = appointmentHistoryDetailsData.typeAttendance === TypeAttendance.SURGERY;
	const isTelehealth =
		appointmentHistoryDetailsData.clinic.telemedicine === TelemedicineEnum.IS_TELEMEDICINE;

	const alertTitle = () => {
		if (isEmergency) return emergencyAppointmentCarriedOut;
		if (isSurgery) return surgeryAppointmentCarriedOut;
		if (isTelehealth) return telehealthAppointmentCarriedOut;
		return appointmentCarriedOut;
	};

	return (
		<Fragment>
			<ConcludedAlert text={alertTitle()} />
			<AppointmentInfo appointmentDetails={appointmentHistoryDetailsData} />
			<Box mt="auto">
				<MainFooter />
			</Box>
		</Fragment>
	);
}
